@if (!affirmative) {
  <ng-container i18n>NOT: </ng-container>
}
@for (childOperator of childOperators; track childOperator; let childOperatorLast = $last) {
  <eas-editor-eligibility-operator-title [operator]="childOperator">
  </eas-editor-eligibility-operator-title>
  @if (!childOperatorLast) {
    {{ function }}
  }
}
